<template>
	<span class="tooltip">
		<span class="tooltip__popup">
			<slot/>
		</span>
	</span>
	<span class="visually-hidden"><slot/></span>
</template>
